import { zodResolver } from "@hookform/resolvers/zod";
import { PatientNoSchema, patientNoSchema } from "@on-site/components/pages/default/schema";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";

export const usePatientNoCheckIn = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  const form = useForm<PatientNoSchema>({
    mode: "onChange",
    resolver: zodResolver(patientNoSchema),
    defaultValues: {
      patientNo: "",
    },
  });

  const handleDebouncedPatientNo = (callback: () => void) => {
    if (timer) {
      clearTimeout(timer);
    }

    const newTimer = setTimeout(() => {
      callback();
    }, 500);

    setTimer(newTimer);
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, [inputRef.current]);

  return { inputRef, form, handleDebouncedPatientNo };
};
